import Map from "../components/Map/Map";

const MapPage = () => <Map />;

export default MapPage;
